import React from 'react';
import FieldSelect from './FieldSelect.jsx';

export default function FieldSelectWeatherCondition(props) {
  const options = [
    'Clear',
    'Dry',
    'Humid',
    'Overcast',
    'Wet',
    'Windy',
  ].map(item => ({ slug: item, value: item }));

  return (
    <FieldSelect
      {...props}
      field="weatherCondition"
      options={options}
    />
  );
}
